import {
  FETCH_DRIVER_PARTNER_SUPPORT_TICKETS_REQUEST,
  FETCH_DRIVER_PARTNER_SUPPORT_TICKETS_SUCCESS,
  FETCH_DRIVER_PARTNER_SUPPORT_TICKETS_FAILURE,
  UPDATE_DRIVER_PARTNER_SUPPORT_TICKET_REQUEST,
  UPDATE_DRIVER_PARTNER_SUPPORT_TICKET_SUCCESS,
  UPDATE_DRIVER_PARTNER_SUPPORT_TICKET_FAILURE,
} from "../actions/types";

const initialState = {
  tickets: [],
  loading: false,
  error: null,
  message: "",
};

const driverPartnerSupportReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case FETCH_DRIVER_PARTNER_SUPPORT_TICKETS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_DRIVER_PARTNER_SUPPORT_TICKETS_SUCCESS:
      return {
        ...state,
        loading: false,
        tickets: action.payload,
        message:
          "Driver Partner Support Tickets loaded successfully",
      };

    case FETCH_DRIVER_PARTNER_SUPPORT_TICKETS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        tickets: [],
      };

    case UPDATE_DRIVER_PARTNER_SUPPORT_TICKET_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case UPDATE_DRIVER_PARTNER_SUPPORT_TICKET_SUCCESS:
      return {
        ...state,
        loading: false,
        tickets: state.tickets.map((ticket) =>
          ticket.ticket_id === action.payload.ticket_id
            ? action.payload
            : ticket
        ),
        message:
          "Driver Partner Support Ticket updated successfully",
      };

    case UPDATE_DRIVER_PARTNER_SUPPORT_TICKET_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default driverPartnerSupportReducer;